/**
 * HostHandoffSplash — 1-second branded splash shown when the user
 * transitions from the console host (e.g. `staging.ascsurvey.com`) to
 * the field-app host (`app.staging.ascsurvey.com`). Mirrors the UX
 * prototype (concerns doc #3): confirms session continuity and names
 * the facility so the user does not wonder whether they got logged
 * out when the tab chrome changes.
 */
export function HostHandoffSplash({ facility }: { facility?: string }) {
  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center gap-3 bg-gradient-to-br from-[var(--brand-deep)] via-[var(--brand-mid)] to-[var(--brand-secondary)] px-6 text-center text-white">
      <div className="h-9 w-9 animate-spin rounded-full border-[3px] border-white/20 border-t-[var(--brand-accent)]" />
      <p className="font-brand text-base font-extrabold tracking-tight">Switching to field mode</p>
      {facility ? (
        <>
          <p className="text-xs text-white/70">Resuming survey at</p>
          <p className="font-brand text-sm font-bold text-[var(--brand-accent)]">{facility}</p>
        </>
      ) : (
        <p className="text-xs text-white/70">Resuming session…</p>
      )}
      <span className="mt-2 inline-flex items-center gap-2 rounded-full border border-emerald-200/30 bg-emerald-200/15 px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.14em] text-emerald-100">
        <span className="h-1.5 w-1.5 rounded-full bg-emerald-200" />
        Session continues
      </span>
    </div>
  )
}
